import react from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

const Calender = (props:any) => {
    return (
        <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            initialView="timeGridDay"
            height="652px"
            themeSystem='bootstrap'
            contentHeight="300px"
            events={
                props.events.map((elm:any) => {
                    return {start:elm.details.From,end:elm.details.From,title:elm.details.title}
                })}
        />
    )

}
export default Calender